import React from 'react';
import { Typography, Row, Col, Button, Grid, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { logEvent } from '../../analytics';

const { Title, Text } = Typography;

const FinalCTA = ({ 
  primaryButtonOnClick,
  secondaryButtonOnClick
}) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const handlePrimaryButtonClick = () => {
    logEvent('Pricing', 'ChoosePlan');
    
    // Scroll to top of the page
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    // Call the original onClick if provided
    if (primaryButtonOnClick) {
      primaryButtonOnClick();
    }
  };

  return (
    <Row justify="center" style={{ 
      padding: '64px 16px',
      marginTop: '-20px'
    }}>
      <Col xs={24} sm={24} md={24} lg={24}>
        <div style={{ 
          maxWidth: '860px', 
          margin: '0 auto'
        }}>
          <Card 
            style={{ 
              textAlign: 'center',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
              border: '1px solid #f0f0f0'
            }}
          >
            <Title 
              level={2} 
              style={{ 
                fontWeight: '600',
                marginBottom: '16px',
                color: '#1a1a1a',
                lineHeight: '1.2',
                letterSpacing: '-0.02em'
              }}
            >
              {t('subscription_final_cta.title')}
            </Title>
            <Text 
              style={{ 
                fontSize: '18px',
                color: '#666',
                marginBottom: '32px',
                display: 'block',
                lineHeight: '1.5'
              }}
            >
              {t('subscription_final_cta.subtitle')}
            </Text>
            <div style={{ 
              display: 'flex', 
              flexDirection: isMobile ? 'column' : 'row',
              gap: '16px',
              justifyContent: 'center',
              marginBottom: '16px'
            }}>
              <Button 
                type="primary" 
                size="large" 
                onClick={handlePrimaryButtonClick}
                style={{ 
                  padding: '0 32px',
                  height: '48px',
                  fontSize: '16px',
                  fontWeight: '500',
                  backgroundColor: 'var(--upgrade-color)',
                  borderColor: 'var(--upgrade-color)'
                }}
              >
                {t('subscription_final_cta.primary_button')}
              </Button>
              <Button 
                size="large" 
                onClick={() => {
                  logEvent('Pricing', 'ScheduleDemo');
                  window.open('https://calendly.com/itaca-ai/llamada', '_blank');
                }}
                style={{ 
                  padding: '0 32px',
                  height: '48px',
                  fontSize: '16px',
                  fontWeight: '500',
                  borderColor: '#d9d9d9',
                  color: '#1a1a1a'
                }}
              >
                {t('subscription_final_cta.secondary_button')}
              </Button>
            </div>
            <Text 
              style={{ 
                fontSize: '14px',
                color: '#666',
                display: 'block',
                lineHeight: '1.4'
              }}
            >
              {t('subscription_final_cta.trust_text')}
            </Text>
          </Card>
        </div>
      </Col>
    </Row>
  );
};

export default FinalCTA; 